const MembershipSubscriptionResource = function ($resource, apiRequestParams, appConfig) {
    return $resource(
        appConfig.apiBaseUrl + 'memberships/',
        apiRequestParams.defaults(),
        {
            updateMultiple: {
                isArray: true,
                method: 'PUT',
                url: appConfig.apiBaseUrl + 'membershipsubscriptions',
            },
        }
    );
};

module.exports = MembershipSubscriptionResource;
